import { call, put } from "redux-saga/effects";
import { goToStep, nextStep } from "../../services/navigation";

import AdesaoActions from "../ducks/adesao";
import RealizePrev from "../../support";
import api from "../../services/api";
import qs from "qs";
import translate from "../../i18n";

interface Documentos {
  documento: File;
  codDocumento?: number;
  codInstituidor?: string;
  cpfBeneficiario?: string;
  idPropostaAdesao?: number;
  idUsuarioInclusao?: number;
  dataInclusao?: string;
}

interface RequestData {
  body: {
    indcConclusaoSolicitacao: string;
    cpf: string;
    cpfParenteParticiapente: string;
    beneficiarios?: [{}];
    documentos: Documentos[];
    nome: string;
    valorContribuicao: string;
    idTipoPlano: string;
    idPatrocinador: string;
    nomeSocial?: string;
    indcAtualizacaoContribuicaoAnual: string;
    senha?: string;
    senhaMinuscula?: string;
    senhaMaiuscula?: string;
    adesaoAssinada?: {
      documento?: string;
      codDocumento?: string;
      cpfBeneficiario?: string;
      idPropostaAdesao?: string;
      codInstituidor?: string;
      idUsuarioInclusao?: string;
      dataInclusao?: string;
      idDocumentoAssinado?: string;
      emailAssinatura?: string;
    };
  };
  cep: string;
  toStep?: boolean;
  numero: string;
  complemento: string;
}

export function* participanteRequest(action: RequestData) {
  try {
    const body = { instituidor: RealizePrev().patrocinadorInstituidor };

    const {
      data: { registros },
    } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/lista/instituidores/v1 ",
      qs.stringify(body)
    );

    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      const { codPatrocinador } = registros[0];
      const body = { plano: codPatrocinador };

      const { data } = yield call(
        api.post,
        "/rest-instituidor/previdencia/realizePrev/externo/lista/plano/v1",
        qs.stringify(body)
      );

      if (data.registros.length === 0) {
        yield put(
          AdesaoActions.adesaoFailure({
            error: translate.t("app.mensagem.erro"),
          })
        );
      } else {
        const { idTipoPlano } = data.registros[0];
        const body = { idTipoPlano };

        const response = yield call(
          api.post,
          "/rest-instituidor/previdencia/realizePrev/externo/busca/valor/contribuicao/minima/v1",
          qs.stringify(body)
        );

        if (response.data.registros.length === 0) {
          yield put(
            AdesaoActions.adesaoFailure({
              error: translate.t("app.mensagem.erro"),
            })
          );
        } else {
          yield put(
            AdesaoActions.adesaoSuccess({
              participante: {
                instituidor: registros,
                plano: data.registros,
                valorMinimoContribuicao: response.data.registros,
              },
            })
          );
        }
      }
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        error: message,
      })
    );
  }
}

export function* participanteAtivoResposta(action: RequestData) {
  try {
    const { body, toStep } = action;

    const {
      data: { registros },
    } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/verifica/inscricao/instituidor/v1",
      qs.stringify(body)
    );

    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      if (registros === "N") {
        const { cpf } = body;

        const { data } = yield call(
          api.post,
          "/rest-instituidor/previdencia/realizePrev/externo/verifica/participante/instituidor/v1",
          qs.stringify({ cpf })
        );
        if (data.registros.length === 0) {
          yield put(
            AdesaoActions.adesaoFailure({
              error: translate.t("app.mensagem.erro"),
            })
          );
        } else {
          if (data.registros.indParticipante === "S") {
            if (toStep) {
              yield put(
                AdesaoActions.salvarParticipante({
                  dadosAdesao: {
                    cpf: body.cpf,
                    nome: body.nome,
                    valorContribuicao: body.valorContribuicao,
                    idPatrocinador: body.idPatrocinador,
                    idTipoPlano: body.idTipoPlano,
                    nomeSocial: body.nomeSocial,
                    indcAtualizacaoContribuicaoAnual:
                      body.indcAtualizacaoContribuicaoAnual,
                  },
                })
              );
              nextStep();
              window.scrollTo(0, 0);
            } else {
              // yield put(
              //   AdesaoActions.salvarParticipante({
              //     buscaParticipante: {
              //       nome: "",
              //     },
              //   })
              // );
              yield put(
                AdesaoActions.salvarParticipante({
                  buscaParticipante: {
                    nome: data.registros.nome,
                  },
                })
              );
            }
          } else {
            yield put(
              AdesaoActions.adesaoFailure({
                error: "Participante não ativo",
              })
            );
          }
        }
      } else {
        yield put(
          AdesaoActions.adesaoFailure({
            error: "Já existe solicitação para o CPF informado",
          })
        );
      }
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        error: message,
      })
    );
  }
}

export function* dadosCadastraisRequest(action: RequestData) {
  try {
    const {
      data: { registros },
    } = yield call(
      api.get,
      "/rest-instituidor/previdencia/realizePrev/externo/lista/nacionalidades/v1"
    );

    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      const { data } = yield call(
        api.get,
        "/rest-instituidor/previdencia/realizePrev/externo/lista/estadoCivis/v1"
      );

      if (data.registros.length === 0) {
        yield put(
          AdesaoActions.adesaoFailure({
            error: translate.t("app.mensagem.erro"),
          })
        );
      } else {
        const body = { idPais: 135 };

        const response = yield call(
          api.post,
          "/rest-cdu/lista/ufs/v1",
          qs.stringify(body)
        );
        if (response.data.registros.length === 0) {
          yield put(
            AdesaoActions.adesaoFailure({
              error: translate.t("app.mensagem.erro"),
            })
          );
        } else {
          yield put(
            AdesaoActions.adesaoSuccess({
              dadosCadastraisPreInfo: {
                nacionalidade: registros,
                estadoCivil: data.registros,
                uf: response.data.registros,
              },
            })
          );
        }
      }
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        error: message,
      })
    );
  }
}

export function* dadosCadastraisCepRequest(action: RequestData) {
  try {
    const { cep, numero, complemento } = action;

    const {
      data: { registros },
    } = yield call(api.get, `/rest-cdu/endereco/cep/v1/${cep}`);

    if (registros === null) {
      yield put(
        AdesaoActions.adesaoFailure({
          errorCEP: "CEP não localizado",
        })
      );
    } else if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      yield put(
        AdesaoActions.adesaoSuccess({
          dadosCadastraisEndereco: {
            endereco: { ...registros, cep, numero, complemento },
          },
        })
      );
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        error: message,
      })
    );
  }
}

export function* dadosCadastraisRespFinanceiroRequest(action: RequestData) {
  try {
    const body = { idPais: 135 };

    const {
      data: { registros },
    } = yield call(api.post, "/rest-cdu/lista/ufs/v1", qs.stringify(body));
    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      yield put(
        AdesaoActions.adesaoSuccess({
          dadosCadastraisRespFinanceiro: {
            uf: registros,
          },
        })
      );
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        error: message,
      })
    );
  }
}

export function* dadosCadastraisRespFinanceiroCepRequest(action: RequestData) {
  try {
    const { cep } = action;

    const {
      data: { registros },
    } = yield call(api.get, `/rest-cdu/endereco/cep/v1/${cep}`);

    if (registros === null) {
      yield put(
        AdesaoActions.adesaoFailure({
          errorCEP: "CEP não localizado",
        })
      );
    } else if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: "Não foi possível conectar com o servidor 1",
        })
      );
    } else {
      yield put(
        AdesaoActions.adesaoSuccess({
          dadosCadastraisRespFinanceiroEndereco: {
            endereco: { ...registros, cep },
          },
        })
      );
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        error: message,
      })
    );
  }
}

export function* parenteParticipanteRequest(action: RequestData) {
  try {
    const body = { instituidor: RealizePrev().patrocinadorInstituidor };

    const {
      data: { registros },
    } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/lista/instituidores/v1 ",
      qs.stringify(body)
    );

    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      const { codPatrocinador } = registros[0];
      const body = { plano: codPatrocinador };

      const { data } = yield call(
        api.post,
        "/rest-instituidor/previdencia/realizePrev/externo/lista/plano/v1",
        qs.stringify(body)
      );

      if (data.registros.length === 0) {
        yield put(
          AdesaoActions.adesaoFailure({
            error: translate.t("app.mensagem.erro"),
          })
        );
      } else {
        const { idTipoPlano } = data.registros[0];
        const body = { idTipoPlano };

        const response = yield call(
          api.post,
          "/rest-instituidor/previdencia/realizePrev/externo/lista/parentesco/v1",
          qs.stringify(body)
        );

        const responseValorContribuicao = yield call(
          api.post,
          "/rest-instituidor/previdencia/realizePrev/externo/busca/valor/contribuicao/minima/v1",
          qs.stringify(body)
        );

        if (response.data.registros.length === 0) {
          yield put(
            AdesaoActions.adesaoFailure({
              error: translate.t("app.mensagem.erro"),
            })
          );
        } else {
          yield put(
            AdesaoActions.adesaoSuccess({
              parenteParticipante: {
                instituidor: registros,
                plano: data.registros,
                parentesco: response.data.registros,
                valorMinimoContribuicao:
                  responseValorContribuicao.data.registros,
              },
            })
          );
        }
      }
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        error: message,
      })
    );
  }
}

export function* associadoEspecialRequest(action: RequestData) {
  try {
    const body = { instituidor: RealizePrev().patrocinadorInstituidor };

    const {
      data: { registros },
    } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/lista/instituidores/v1 ",
      qs.stringify(body)
    );

    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      const { codPatrocinador } = registros[0];
      const body = { plano: codPatrocinador };

      const { data } = yield call(
        api.post,
        "/rest-instituidor/previdencia/realizePrev/externo/lista/plano/v1",
        qs.stringify(body)
      );

      if (data.registros.length === 0) {
        yield put(
          AdesaoActions.adesaoFailure({
            error: translate.t("app.mensagem.erro"),
          })
        );
      } else {
        const { idTipoPlano } = data.registros[0];
        const body = { idTipoPlano };

        const response = yield call(
          api.post,
          "/rest-instituidor/previdencia/realizePrev/externo/lista/parentesco/v1",
          qs.stringify(body)
        );

        const responseValorContribuicao = yield call(
          api.post,
          "/rest-instituidor/previdencia/realizePrev/externo/busca/valor/contribuicao/minima/v1",
          qs.stringify(body)
        );

        if (response.data.registros.length === 0) {
          yield put(
            AdesaoActions.adesaoFailure({
              error: translate.t("app.mensagem.erro"),
            })
          );
        } else {
          yield put(
            AdesaoActions.adesaoSuccess({
              associadoEspecial: {
                instituidor: registros,
                plano: data.registros,
                parentesco: response.data.registros,
                valorMinimoContribuicao:
                  responseValorContribuicao.data.registros,
              },
            })
          );
        }
      }
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        error: message,
      })
    );
  }
}

export function* parenteParticipanteAtivoResposta(action: RequestData) {
  let erroParticipnte = true;
  try {
    const { body, toStep } = action;

    const { cpf } = body;

    const { data } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/verifica/participante/instituidor/v1",
      qs.stringify({ cpf })
    );
    if (data.registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      if (data.registros.indParticipante === "S") {
        if (toStep) {
          const {
            data: { registros },
          } = yield call(
            api.post,
            "/rest-instituidor/previdencia/realizePrev/externo/verifica/inscricao/instituidor/v1",
            qs.stringify({ ...body, cpf: body.cpfParenteParticiapente })
          );
          if (registros.length === 0) {
            yield put(
              AdesaoActions.adesaoFailure({
                error: translate.t("app.mensagem.erro"),
              })
            );
          } else {
            erroParticipnte = false;
            if (registros === "N") {
              nextStep();
              window.scrollTo(0, 0);
            } else {
              yield put(
                AdesaoActions.adesaoFailure({
                  errorCpfParenteParticiapente:
                    "Já existe solicitação para o CPF informado",
                })
              );
            }
          }
        } else {
          yield put(
            AdesaoActions.salvarParticipante({
              buscaParticipante: {
                nome: "",
              },
            })
          );
          yield put(
            AdesaoActions.salvarParticipante({
              buscaParticipante: {
                nome: data.registros.nome,
              },
            })
          );
        }
      } else {
        yield put(
          AdesaoActions.adesaoFailure({
            error: "Participante não ativo",
          })
        );
      }
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure(
        erroParticipnte
          ? { error: message }
          : { errorCpfParenteParticiapente: message }
      )
    );
  }
}

export function* importarDadosCadastraisRequest(action: RequestData) {
  try {
    const { body } = action;

    const responseSenha = yield call(
      api.post,
      "/rest-autenticacao/autenticador/encrypt/v1",
      qs.stringify({ valor: body.senha })
    );
    const responseSenhaMinuscula = yield call(
      api.post,
      "/rest-autenticacao/autenticador/encrypt/v1",
      qs.stringify({ valor: body.senhaMinuscula })
    );
    const responseSenhaMaiuscula = yield call(
      api.post,
      "/rest-autenticacao/autenticador/encrypt/v1",
      qs.stringify({ valor: body.senhaMaiuscula })
    );

    const senha = responseSenha.data.registros;
    const senhaMinuscula = responseSenhaMinuscula.data.registros;
    const senhaMaiuscula = responseSenhaMaiuscula.data.registros;

    const {
      data: { registros },
    } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/dados/participante/v1",
      qs.stringify({ ...body, senha, senhaMinuscula, senhaMaiuscula })
    );

    if (registros) {
      yield put(
        AdesaoActions.adesaoSuccess({
          dadosAdesao: {
            cpf: registros.cpf,
            nome: registros.nome,
          },
          dadosCadastrais: {
            pessoa: {
              rg: {
                numero: registros.rg,
                orgaoExpedidor: registros.orgaoEmissorRg,
                uf: registros.ufEmissorRg,
                dataExpedicao: registros.dataExpedicaoRg,
              },
              cnh: {
                numero: registros.numeroCnh,

                uf: registros.ufCnh,
                dataExpedicao: registros.dataExpedicaoCnh,
              },
              email: registros.email,
              telefone:
                registros.dddFoneResidencial && registros.numeroFoneResidencial
                  ? `(${
                      registros.dddFoneResidencial.length === 3
                        ? registros.dddFoneResidencial
                        : `0` + registros.dddFoneResidencial
                    }) ${registros.numeroFoneResidencial}`
                  : "",
              celular:
                registros.dddCelular && registros.numeroFoneCelular
                  ? `(${
                      registros.dddCelular && registros.dddCelular.length === 3
                        ? registros.dddCelular
                        : `0` + registros.dddCelular
                    }) ${registros.numeroFoneCelular}`
                  : "",
              sexo: registros.sexo,
              nacionalidade: registros.idNacionalidade,
              estadoCivil: registros.idEstadoCivil,
              dataNascimento: registros.dataNascimento,
              nomeFiliacao1: registros.nomeMae,
              nomeFiliacao2: registros.nomePai,
            },
          },
          dadosCadastraisEndereco: {
            endereco: {
              descLogradouro: "",
              descBairro: "",
              descUf: "",
              descCidade: "",
              numero: registros.numeroLogradouro,
              cep: registros.cep,
              complemento: registros.complementoLogradouro,
            },
          },
        })
      );
    } else {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        errorLogin: message,
      })
    );
  }
}

export function* documentosRequest(action: RequestData) {
  try {
    const body = { idTipoPlano: 4 };

    const {
      data: { registros },
    } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/lista/documento/v1 ",
      qs.stringify(body)
    );

    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      const body = { parametro: "EXTENSOES_ANEXO" };

      const { data } = yield call(
        api.post,
        "/rest-instituidor/previdencia/realizePrev/externo/retorna/valor/parametro/v1",
        qs.stringify(body)
      );

      if (data.registros.length === 0) {
        yield put(
          AdesaoActions.adesaoFailure({
            error: translate.t("app.mensagem.erro"),
          })
        );
      } else {
        const body = { parametro: "TAM_MAX_ANEXO" };

        const response = yield call(
          api.post,
          "/rest-instituidor/previdencia/realizePrev/externo/retorna/valor/parametro/v1",
          qs.stringify(body)
        );

        if (response.data.registros.length === 0) {
          yield put(
            AdesaoActions.adesaoFailure({
              error: translate.t("app.mensagem.erro"),
            })
          );
        } else {
          yield put(
            AdesaoActions.adesaoSuccess({
              documentos: {
                documentos: registros,
                extencoes: data.registros,
                tamanho: response.data.registros,
              },
            })
          );
        }
      }
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        error: message,
      })
    );
  }
}

export function* inserirAdesaoRequest(action: RequestData) {
  try {
    const { body, toStep } = action;

    const {
      data: { registros },
    } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/cadastra/proposta/adesao/v1",
      qs.stringify(body)
    );

    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          errorCadastro: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      yield put(
        AdesaoActions.salvarParticipante({
          dadosAdesao: { ...body, idPropostaAdesao: registros },
        })
      );
      if (toStep) {
        goToStep(5);
        window.scrollTo(0, 0);
      } else {
        nextStep();
        window.scrollTo(0, 0);
      }
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        errorCadastro: message,
      })
    );
  }
}

export function* atualizarAdesaoRequest(action: RequestData) {
  try {
    const { body } = action;

    const {
      data: { registros },
    } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/atualiza/proposta/adesao/v1 ",
      qs.stringify(body)
    );

    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      yield put(
        AdesaoActions.salvarParticipante({
          dadosAdesao: { ...body, idPropostaAdesao: registros },
        })
      );
      nextStep();
      window.scrollTo(0, 0);
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        errorAtualizar: message,
      })
    );
  }
}

export function* inserirBeneficiarioAdesaoRequest(action: RequestData) {
  try {
    const { body } = action;
    const {
      data: { registros },
    } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/cadastra/beneficiario/v1",
      {
        beneficiarios: body.beneficiarios,
      }
    );

    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          errorConfirmacao: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      yield put(AdesaoActions.atualizarAdesaoRequest(body));
    }
    //nextStep!();
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        errorConfirmacao: message,
      })
    );
  }
}

export function* inserirDocumentoAdesaoRequest(action: RequestData) {
  try {
    let { body } = action;

    const {
      data: { registros },
    } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/anexa/documento/comprobatorio/adesao/v1",
      body.documentos
    );

    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          errorConfirmacao: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      body = {
        ...body,
        indcConclusaoSolicitacao: "S",
        documentos: [],
      };

      if (body.beneficiarios && body.beneficiarios?.length > 0) {
        yield put(AdesaoActions.inserirBeneficiarioAdesaoRequest(body));
      } else {
        yield put(AdesaoActions.atualizarAdesaoRequest(body));
      }
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        errorConfirmacao: message,
      })
    );
  }
}

export function* solicitaAssinaturaRequest(action: any) {
  try {
    const { body } = action;
    const formData = new FormData();
    formData.append("idPasta", body.idPasta);
    formData.append("cpfSignatario", body.cpfSignatario);
    formData.append("emailSignatario", body.emailSignatario);
    formData.append("sharepointSistema", body.sharepointSistema);
    formData.append("sharepointDominio", body.sharepointDominio);
    formData.append("sharepointArea", body.sharepointArea);
    formData.append("sharepointBiblioteca", body.sharepointBiblioteca);
    formData.append("sharepointDiretorio", body.sharepointDiretorio);
    formData.append("sharepointMetadado", body.sharepointMetadado);

    formData.append("arquivo", body.arquivo);

    const {
      data: { registros, status, mensagem },
    } = yield call(
      api.post,
      "/rest-assinatura-digital/solicitaAssinatura/v1",
      formData,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }
    );

    yield resultado(
      { tokenValido: true, dadosAssinatura: registros },
      status,
      mensagem
    );
    //mock
    /*yield resultado(
      {
        tokenValido: true,
        dadosAssinatura: {
          idDocumento: "d43115c2-edbb-11ec-9637-0242ac110003",
          idPastaFornecedor: "ad076c15-f294-11ec-9637-0242ac11003",
          cpf: "04363856432",
          documentoOriginal: "array de bytes do arquivo.....",
          statusDocumento: "3",
          dataCadastro: "2022-06-17T00:32:31.000+00:00",
          idDocumentoFornecedor: "b0770043-b419-4626-9d37-34ce79a03531",
        },
      },
      "S",
      "mensagem"
    );*/
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield resultado({ tokenValido: true }, "E", message);
  }
}

export function* documentoAssinadoRequest(action: any) {
  try {
    const { idDocumentoFornecedor } = action;
    const {
      data: { registros, status, mensagem },
    } = yield call(
      api.get,
      "/rest-assinatura-digital/documento/assinado/v1?idDocumentoFornecedor=" +
        idDocumentoFornecedor
    );

    yield resultado(
      { tokenValido: true, documentoAssinado: registros },
      status,
      mensagem
    );
    //mock
    /*yield resultado(
      {
        tokenValido: true,
        documentoAssinado: {
          idDocumento: "d43115c2-edbb-11ec-9637-0242ac110003",
          idPastaFornecedor: "ad076c15-f294-11ec-9637-0242ac110003",
          cpf: "04363856432",
          documentoOriginal: "array de bytes do arquivo.....",
          statusDocumento: "3",
          dataCadastro: "2022-06-17T00:32:31.000+00:00",
          idDocumentoFornecedor: "b0770043-b419-4626-9d37-34ce79a03531",
        },
      },
      "E",
      "mensagem"
    );*/
  } catch (error) {
    let message = translate.t("app.mensagem.ocorreuErro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield resultado({ tokenValido: true }, "E", message);
  }
}

function* resultado(obj: any, status: string, mensagem: string) {
  if (status === "S") {
    yield put(AdesaoActions.adesaoSuccess(obj));
  } else {
    if (mensagem) {
      yield put(AdesaoActions.adesaoFailure({ errorConfirmacao: mensagem }));
    } else {
      yield put(
        AdesaoActions.adesaoFailure({
          errorConfirmacao: translate.t("app.mensagem.erro"),
        })
      );
    }
  }
}

export function* parametrosConfirmacaoRequest(action: RequestData) {
  try {
    const { body } = action;
    const patrocinador = { patrocinador: body };

    const {
      data: { registros },
    } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/retorna/valor/pasta/adesao/patrocinador/v1",
      qs.stringify(patrocinador)
    );

    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      const body = { parametro: "DOMINIO_SHAREPOINT" };

      const { data } = yield call(
        api.post,
        "/rest-instituidor/previdencia/realizePrev/externo/retorna/valor/parametro/v1",
        qs.stringify(body)
      );

      if (data.registros.length === 0) {
        yield put(
          AdesaoActions.adesaoFailure({
            error: translate.t("app.mensagem.erro"),
          })
        );
      } else {
        const body = { parametro: "BIBL_SHAREPOINT" };

        const response = yield call(
          api.post,
          "/rest-instituidor/previdencia/realizePrev/externo/retorna/valor/parametro/v1",
          qs.stringify(body)
        );

        if (response.data.registros.length === 0) {
          yield put(
            AdesaoActions.adesaoFailure({
              error: translate.t("app.mensagem.erro"),
            })
          );
        } else {
          const body = { parametro: "AREA_SHAREPOINT" };

          const responseArea = yield call(
            api.post,
            "/rest-instituidor/previdencia/realizePrev/externo/retorna/valor/parametro/v1",
            qs.stringify(body)
          );

          if (responseArea.data.registros.length === 0) {
            yield put(
              AdesaoActions.adesaoFailure({
                error: translate.t("app.mensagem.erro"),
              })
            );
          } else {
            yield put(
              AdesaoActions.adesaoSuccessNotCleanError({
                confirmacaoParamtros: {
                  idPasta: registros.pastaAssinaturaAdesao,
                  dominioSharePoint: data.registros,
                  biblSharePoint: response.data.registros,
                  sharepointArea: responseArea.data.registros,
                },
              })
            );
          }
        }
      }
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      AdesaoActions.adesaoFailure({
        error: message,
      })
    );
  }
}

export function* verificaInscricaoInstituidorRequest(action: RequestData) {
  try {
    const { body } = action;
    const {
      data: { registros },
    } = yield call(
      api.post,
      "/rest-instituidor/previdencia/realizePrev/externo/verifica/inscricao/instituidor/v1",
      qs.stringify({ ...body })
    );
    if (registros.length === 0) {
      yield put(
        AdesaoActions.adesaoFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    } else {
      if (registros === "N") {
        nextStep();
        window.scrollTo(0, 0);
      } else {
        yield put(
          AdesaoActions.adesaoFailure({
            errorCpfParenteParticiapente:
              "Já existe solicitação para o CPF informado",
          })
        );
      }
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(AdesaoActions.adesaoFailure({ error: message }));
  }
}
